var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[(!_vm.$route.meta.external && _vm.$route.name != 'Home')?[(_vm.$route.name == 'RegistrationPage')?_c('RegisterHead'):_c('HeadPage')]:_vm._e(),_c('transition',[_c('keep-alive',{attrs:{"include":"Index"}},[_c('router-view')],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }